import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SearchRequestModel } from '../models/search-request-model';
import { SearchResultsModel } from '../models/search-results-model';
import { BaseService } from './base.service';
import { ConstantsService } from './constants.service';
import { SearchOutputModel } from '../models/search-output-model';
import { SuggestRequestModel } from '../models/suggest-request-model';

@Injectable({
  providedIn: 'root'
})
export class PubSearchService extends BaseService {

  constructor(public override http: HttpClient,
    public override constants: ConstantsService) {
    super(http, constants, constants.api_azsearch);
  }

  getSearchResults(item: string) {
    return this.http.post(this.api + environment.api_code, item)
      .pipe(catchError((e: any) => this.handleError(e)));
  }

  getSearchResultsReq(item: SearchRequestModel): Observable<SearchOutputModel> {
    return this.http.post<SearchOutputModel>(this.api + environment.api_code, item)
      .pipe(catchError(this.handleError));
  }

  getSearchResultsReqMdOnly(item: SearchRequestModel): Observable<SearchOutputModel> {
    return this.http.post<SearchOutputModel>(this.api + environment.api_code, item)
      .pipe(catchError(this.handleError));
  }

  getDocDetails(id: string): Observable<SearchResultsModel> {
    return this.http.get<SearchResultsModel>(this.constants.api_azsearch_document + "/" + id + environment.api_code)
  }

  getSuggestions(query: SuggestRequestModel): Observable<string[]> {
    return this.http.post<string[]>(this.constants.api_azsearch_suggest + environment.api_code, query)
      .pipe(catchError(this.handleError));
  }

  getFacetSuggestions(query: SuggestRequestModel): Observable<string[]> {
    return this.http.post<string[]>(this.constants.api_azsearch_suggest_facet + environment.api_code, query)
      .pipe(catchError(this.handleError));
  }

  downloadItems(item: SearchRequestModel): Observable<SearchOutputModel> {
    return this.http.post<SearchOutputModel>(this.constants.api_azsearch_download + environment.api_code, item)
    .pipe(catchError(this.handleError));
  }
}
